/**
 * Model to hold data, when changing user password.
 */
export class ChangePassword {
  public constructor(public oldPassword = '', public newPassword = '', public newPasswordConfirm = '') {}

  public checkPasswordConfirm(): boolean {
    return this.newPasswordConfirm === this.newPassword;
  }

  /**
   * Clear all data in the object.
   */
  public clear(): void {
    this.oldPassword = '';
    this.newPassword = '';
    this.newPasswordConfirm = '';
  }
}
